export type DestinationTabFilter = "All" | "Popular" | "New";
export type DestinationRegionFilter = "All Regions" | "Europe" | "Asia" | "Africa" | "Americas" | "Middle East";
export type DestinationTravelTypeFilter = "All Types" | "Honeymoon" | "Family" | "Cultural" | "Adventure";
export type DestinationSeasonFilter = "Any Season" |"Summer" |"Monsoon" |"Autumn" |"Spring" | "Winter";

export type DestinationBrowseFilters = {
  tab: DestinationTabFilter;
  region: DestinationRegionFilter;
  travelType: DestinationTravelTypeFilter;
  season: DestinationSeasonFilter;
};

export const destinationBrowseOptions = {
  tabs: ["All", "Popular", "New"] as DestinationTabFilter[],
regions: [
    "All Regions",
    "Europe",
    "Asia",
    "Middle East",
    "Africa",
    "Americas"
  ]  as DestinationRegionFilter[],
 travelTypes: [
    "All Types",
    "Honeymoon",
    "Family",
    "Cultural",
    "Adventure",
  ] as DestinationTravelTypeFilter[],
  seasons: ["Any Season", "Summer", "Monsoon", "Autumn", "Spring", "Winter"] as DestinationSeasonFilter[],
} as const;
